export enum MqttTransformationType {
    json,
    raw,
}
